module.exports = __webpack_public_path__ + "691fdea463795a7e99383b35c9f8515a.svg";